export default {"src":"/_next/static/media/dimension-logo-new.aa61ae52.svg","height":18,"width":124,"blurWidth":0,"blurHeight":0};